import React from "react";

function Overview() {
    return (
        <div className="white-bg" style={{ padding: "20px" }}>
            <h1>Health Center</h1>
            <p className="caboutus">
                The Health Centre is committed to promoting the health and
                wellness of the campus community by providing high-quality
                prevention, education, and treatment services. The medical,
                counseling, and health promotion services are designed to help
                you stay healthy or get better so that you can minimize
                disruptions caused by injury and illness. The Health Centre aims
                to enhance the healthcare experience of the IIT Tirupati campus
                community by providing healthcare with respect, consideration
                and confidentiality. Please review this website or reach out to
                the Heath Centre staff for details of healthcare resources,
                prevention methods, health education and general healthcare
                guidance.
            </p>
            <h3><b style={{ color: "red" }}>Emergency Contact No: 7901070270</b></h3>
        </div>
    );
}

export default Overview;
